"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OktonCollapseCard = void 0;
const react_1 = require("@chakra-ui/react");
const react_2 = __importDefault(require("react"));
const lu_1 = require("react-icons/lu");
const OktonCollapseCard = ({ title, subtitle, children, headerChildren, defaultOpen = true, collapsible = true, }) => {
    const [isOpen, setIsOpen] = react_2.default.useState(defaultOpen);
    const bg = (0, react_1.useColorModeValue)("white", "gray.800");
    const borderColor = (0, react_1.useColorModeValue)("gray.200", "gray.700");
    const titleColor = (0, react_1.useColorModeValue)("gray.800", "whiteAlpha.900");
    const subtitleColor = (0, react_1.useColorModeValue)("gray.600", "gray.400");
    return (react_2.default.createElement(react_1.Box, { bg: bg, borderWidth: "1px", borderColor: borderColor, borderRadius: "lg", shadow: "sm", overflow: "hidden" },
        react_2.default.createElement(react_1.Flex, { align: "center", justify: "space-between", gap: "4", p: "5", cursor: collapsible ? "pointer" : "default", onClick: collapsible ? () => setIsOpen((open) => !open) : undefined },
            react_2.default.createElement(react_1.VStack, { align: "start", spacing: "1" },
                react_2.default.createElement(react_1.Heading, { size: "sm", fontWeight: "bold", color: titleColor }, title),
                subtitle ? (react_2.default.createElement(react_1.Text, { fontSize: "xs", color: subtitleColor }, subtitle)) : null),
            react_2.default.createElement(react_1.Flex, { align: "center", gap: "3" },
                headerChildren,
                collapsible ? (react_2.default.createElement(react_1.Icon, { as: (isOpen ? lu_1.LuChevronUp : lu_1.LuChevronDown), boxSize: "5" })) : null)),
        collapsible ? (react_2.default.createElement(react_1.Collapse, { in: isOpen, animateOpacity: true },
            react_2.default.createElement(react_1.Box, { px: "5", pb: "5" }, children))) : (react_2.default.createElement(react_1.Box, { px: "5", pb: "5" }, children))));
};
exports.OktonCollapseCard = OktonCollapseCard;
//# sourceMappingURL=index.js.map